import { AbstractControl, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';

export class TrancheGroesseValidator {

    public static readonly TRANCHEN_MAX_2_DECIMAL = 100;
    public static readonly TRANCHE_PATTERN_2_DECIMAL = new RegExp('^\\d{0,3}([\.,][\\d]{1,2})?$');

    static get validator2(): ValidatorFn[] {




        return [
            Validators.max(TrancheGroesseValidator.TRANCHEN_MAX_2_DECIMAL),
            Validators.pattern(TrancheGroesseValidator.TRANCHE_PATTERN_2_DECIMAL),
            this.validate(),
        ];
    }

    static validate(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            if (!control.value) {
                return null;
            }


            // I don't have an idea, needed due to angular/typescript form controls
            //  typed/untyped difference between tranche-sub-form and planwert-detail-form
            if (typeof  control.value != 'number') {
                const dotSeparatedDecimalNumber = control.value.replace(',', '.');

                if (dotSeparatedDecimalNumber < 0) {
                    return { min: true };
                } else if (dotSeparatedDecimalNumber > 100) {
                    return { max: true };
                }
            }


            return null;
        };
    }
}
